"use client"

import { Head, router, useForm } from "@inertiajs/react"

import { Breadcrumbs } from "@/components/ui/breadcrumbs"
import { AuthedShell } from "@/layouts/authed-shell"

import PlaylistForm from "./_components/playlist-form"

export default function NewPlaylist() {
  const { data, setData, post, processing, errors } = useForm({
    playlist: {
      title: "",
      description: "",
      cover_image: null as File | null,
      published: false,
    },
  })

  const submit = (e: React.FormEvent) => {
    e.preventDefault()
    post("/playlists", {
      forceFormData: true,
    })
  }

  return (
    <AuthedShell headerVariant="light">
      <Head title="Create Playlist" />
      <section className="bg-secondary mb-3 pt-6 pb-8">
        <div className="max-w-container mx-auto px-4 lg:px-8">
          {/* Breadcrumbs */}
          <div className="mb-3">
            <Breadcrumbs maxVisibleItems={3} />
          </div>
          {/* Page header */}
          <div className="flex flex-1 flex-col justify-center gap-0.5 self-stretch">
            <h1 className="text-primary font-display md:text-display-xs text-xl font-semibold">
              Create Playlist
            </h1>
            <p className="text-md text-tertiary">
              Create a new playlist to organize and share your favorite content.
            </p>
          </div>
        </div>
      </section>

      <div className="max-w-container mx-auto mb-8 flex min-h-[calc(80vh)] w-full flex-1 flex-col gap-5 px-4 lg:px-8">
        <PlaylistForm
          data={data.playlist}
          setData={(next) => setData("playlist", next)}
          errors={errors as Record<string, string | undefined>}
          processing={processing}
          initialDescription=""
          coverErrorKey="playlist.cover_image"
          submitLabel="Create Playlist"
          removeLabel="Remove"
          onSubmit={submit}
          onCancel={() => router.visit("/playlists/owned")}
        />
      </div>
    </AuthedShell>
  )
}
